import React from "react";
import { moneyPrefix, moneySuffix } from "../../../../../utils/money";
import NumericFormat from "react-number-format";
import { useTranslation } from "react-i18next";
import PointsView from "../../../../Shared/PointsView";

interface RevenueHistoryItemRawStudentRawProps {
  avatar?: string,
  userName?: string,
  points?: number
}

const RevenueHistoryItemRawStudentRaw = (props: RevenueHistoryItemRawStudentRawProps) => {
  const { avatar, userName, points } = props;
  const { i18n } = useTranslation();
  return (
    <li>
      <div className="img-wrapper">
        <img src={avatar} alt="" />
      </div>
      <p>{userName}</p>
      <h3>
        <NumericFormat
          value={points}
          prefix={moneyPrefix(i18n.language)}
          suffix={moneySuffix(i18n.language)}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          displayType="text"
          renderText={(value) => <React.Fragment>{value}</React.Fragment>}
        />
      </h3>
    </li>
  );
};

export default RevenueHistoryItemRawStudentRaw;
